import axios from 'axios';
import dxDataGrid from 'devextreme/ui/data_grid';
var convert = require('xml-js');
let unique_ids = [];
let unique_ids_data_obj = [];
let unique_id_column=[];
let Exceldata_verify=[];
var Exceldata=[];
var vouchertypename ='';
var VOUCHERTYPENAME='';
let veritfy_master_template=[];
let stock_item=[];
let ledger=[];
let voucher='';
let vouchercreate=[];

//fetch company from db
function getCompanyNames_db(_this){
    axios.get('tc-integrates/get_company')
        .then((result)=>{
            var companies = [];
            companies = result.data;
            if (companies.length == 0) {
                $("#company").find('option').remove();
            }
            else {
                $.each(companies, function (key, value) {
                    if (value.length > 0) {
                        $("#company").find('option').remove();
                    }
                    else{

                    }
                })
                $.each(companies, function (key, value) {
                    if (value.length > 0){
                        if(_this.companyOptions.items.indexOf(value) == -1)
                          _this.companyOptions.items.push(value);
                    }
                    else{
                        
                    }
                })
            }
    })
}

function getJsonTemplatePhp(_this,template_params,meta,datasource){
    console.log("JsonTemplatePhp");
    upload(template_params,_this.file[0],_this,meta,datasource);
    _this.template_data = template_params.json_template;

}

function verifyMaster (_this,meta) {
    _this.VOUCHERTYPENAME =_this.template_data.VOUCHERTYPENAME;
    voucher =_this.template_data.VOUCHERTYPENAME;
    veritfy_master_template =_this.template_data;
    verify_master_fields_loop(veritfy_master_template,_this);
    verify_master_fields(_this,meta)

}

function  upload (template_params,file,_this,meta,datasource) {
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(file.name.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        var edata = ProcessExcel(e.target.result,template_params.unique_id_col,_this,template_params.aggregate_fields_array,datasource);
                        _this.Exceldata = edata;
                        verifyMaster(_this,meta);
                    };
                     reader.readAsBinaryString(file);
                } else {
                    
                }
            } else {
                $window.alert("This browser does not support HTML5.");
            }
        } else {
            $window.alert("Please upload a valid Excel file.");
        }
};

function ProcessExcel(data,unique_id_col,_this,aggregate_array,datasource){
    //Read the Excel File data.
    var unique_id_column = unique_id_col;
   
    var XLSX = require('xlsx');
    var workbook = XLSX.read(data, {
        type: 'binary'
    });

    //Fetch the name of First Sheet.
    var firstSheet = workbook.SheetNames[0];
    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
    
    if(datasource){
        Exceldata_verify = datasource;
        var result = _.groupBy(datasource, unique_id_column);
        var output = [];
        var count = 0;
        var col_for_sum = aggregate_array;//["Amount", "PKT", "Level","GST Amount"]

        $.each(result, function (key, value) {
            var result1 = value.reduce((acc, n) => {
                for (var prop in n) {
                    if (acc.hasOwnProperty(prop) && col_for_sum.indexOf(prop) != -1) acc[prop] += n[prop];
                    else acc[prop] = n[prop];
                }
                return acc;
            }, {})
            output.push(result1);
        })
        $.each(result, function (key, value) {
            for (var i = 0; i < 1; i++) {
                value.splice(0, 0, output[count])
                count++
            }
        })
        return result;
    }
    else{
        Exceldata_verify = excelRows;
        var result = _.groupBy(excelRows, unique_id_column);
        var output = [];
        var count = 0;
        var col_for_sum = aggregate_array;//["Amount", "PKT", "Level","GST Amount"]
        $.each(result, function (key, value) {
            var result1 = value.reduce((acc, n) => {
                for (var prop in n) {
                    if (acc.hasOwnProperty(prop) && col_for_sum.indexOf(prop) != -1) acc[prop] += n[prop];
                    else acc[prop] = n[prop];
                }
                return acc;
            }, {})
            output.push(result1);
        })
        $.each(result, function (key, value) {
            for (var i = 0; i < 1; i++) {
                value.splice(0, 0, output[count])
                count++
            }
        })
        return result;
    }
   // Display the data from Excel file in Table.
};

//populating masters arrays for verification purpose 
function verify_master_fields_loop(obj,_this) {
    $.each(Exceldata_verify, function (k_l,v_l) {
        data_render(obj,_this);
        function data_render(obj,_this) {
            if (obj) {
                $.each(obj, function ( key,value) {
                    if (Array.isArray(value) == true) {
                        verify_master_fields_loop(value,_this);
                    }
                    else if (typeof value === 'object' == true) {
                        verify_master_fields_loop(value,_this);
                    }
                    else {
                        $.each(v_l, function (k,v) {
                            if (key == "VOUCHERTYPENAME") {
                                VOUCHERTYPENAME = value;
                            }
                            if (key == "STOCKITEMNAME" && k == value) {
                                if (_this.stockitem.indexOf(v) == -1) {
                                    _this.stockitem.push(v);
                                    stock_item.push(v)
                                }
                            }
                            else if (key == "LEDGERNAME" && k == value) {
                                if (_this.ledgername.indexOf(v) == -1) {
                                    _this.ledgername.push(v);
                                    ledger.push(v)
                                }
                            }
                        })
                    }
                })
            }
        }
    })
}

function verify_master_fields(_this,meta) {
   
   var params = {"voucher_type_name":_this.VOUCHERTYPENAME,"ledgername":_this.ledgername,"stockitem":_this.stockitem};
   meta = "electron";
   if(meta=="electron"){
       // window.api.send('verify_master_list',{"ledger":ledger,'stock':stock_item,'voucher':voucher});
        
        window.api.verifyMasterList({"ledger":ledger,'stock':stock_item,'voucher':voucher});   
        window.api.verifyMasterListReply((event,res_obj)=>{

                _this.ledgername_ver =res_obj.ledger;
                _this.stockitem_ver =res_obj.stock;
                _this.ledgername_count =  _this.ledgername_ver.filter(item => item.status === "dont_exists").length;
                _this.stockitem_count =  _this.stockitem_ver.filter(item => item.status === "dont_exists").length;
               
            })
      


    }
    else{
        axios.post('verify_master_test',params)
        .then((result)=>{
            console.log("verify_master_test Result",result)
            _this.ledgername_ver = result.data.ledger_verify_arr;
            _this.ledgername_count = result.data.ledger_verify_arr.filter(item => item.status === "dont_exists").length;
            $.each(result.data.stock_verify_arr,function(key,value){
                   var result1 = convert.xml2json(value, { compact: true, spaces: 4 });
                   var jsonObj = JSON.parse(result1);
                   var jsonObj1 = Object.keys(jsonObj)
                   if (jsonObj1.includes('ERRORMSG') == true) {
                       _this.stockitem_ver.push({ "name": jsonObj.ENVELOPE.BODY.DATA.TALLYMESSAGE.STOCKITEM._attributes.NAME, "status": "dont_exists" })
                   }
                   else {
                       _this.stockitem_ver.push({ "name": jsonObj.ENVELOPE.BODY.DATA.TALLYMESSAGE.STOCKITEM._attributes.NAME, "status": "exists", "unit": jsonObj.ENVELOPE.BODY.DATA.TALLYMESSAGE.STOCKITEM.BASEUNITS._text })
                   }
            })
            _this.stockitem_count=_this.stockitem_ver.filter(item => item.status === "dont_exists").length
            _this.voucher_ver =result.data.voucher_verify_arr;
            _this.voucher_count =  _this.voucher_ver.filter(item => item.status === "dont_exists").length;
        })
    }
}

 //Recursion loop starts
 let unit = "";
 let billed_qty = "";
 let cr_value =0;
 let dr_value =0;
 let dr_cr_diff=0;
 let change_value='';
 let array = [];
 
 function voucher_data_render(obj,obj_view,vhc_type,_this,meta) {

    meta = "electron" ;
     if(_this.count <1){
        _this.voucher_create = [];
        vouchercreate=[];
        var template = JSON.parse(JSON.stringify(obj));
        $.each(_this.Exceldata, function (key_unique_id_array,value_unique_id_array) {
            cr_value =0;
            dr_value =0;
            dr_cr_diff=0;
            var json_data = JSON.parse(JSON.stringify(obj));
            data_render(template, json_data,value_unique_id_array,_this);
            var options = { compact: true, ignoreComment: true, spaces: 4 };
            var xmlstr = "<ENVELOPE>";
            xmlstr += "<HEADER>";
            xmlstr += "<TALLYREQUEST>Import Data</TALLYREQUEST>";
            xmlstr += "</HEADER>";
            xmlstr += "<BODY>";
            xmlstr += "<IMPORTDATA>";
            xmlstr += "<REQUESTDESC>";
            xmlstr += "<REPORTNAME>Vouchers</REPORTNAME>";
            xmlstr += "<STATICVARIABLES>";
            xmlstr += "<SVCURRENTCOMPANY>Sparsh</SVCURRENTCOMPANY>";
            xmlstr += "</STATICVARIABLES>";
            xmlstr += "</REQUESTDESC>";
            xmlstr += "<REQUESTDATA>";
            xmlstr += "<TALLYMESSAGE xmlns:UDF='TallyUDF'>";
            xmlstr += "<VOUCHER  VCHTYPE =" + "\"" + vhc_type + "\" ACTION =" + "\"" + "Create" + "\" OBJVIEW =" + "\"" + obj_view + "\">";
            xmlstr += convert.json2xml(JSON.stringify(json_data, true), options);
            xmlstr += "</VOUCHER>";
            xmlstr += "</TALLYMESSAGE>";
            xmlstr += "</REQUESTDATA>";
            xmlstr += "</IMPORTDATA>";
            xmlstr += "</BODY>";
            xmlstr += "</ENVELOPE>";
            _this.voucher_create.push(xmlstr);
            vouchercreate.push(json_data);
        })
        if(meta=="electron"){      
            var params={"voucher":vouchercreate,"obj_view":obj_view,"vch_type":vhc_type};
            //window.api.send('ImportJsonTemplateToTally_vocher',params); 

            window.api.ImportJsonTemplateToTallyVoucher(params);




            window.api.receive("inserted_data_into_tally-reply", (res_obj) => {
                _this.count = 0;
                _this.created = 0;
                _this.ALTERED = 0;
                _this.CANCELLED = 0;
                _this.COMBINED = 0;
                _this.DELETED = 0;
                _this.ERRORS = 0;
                _this.IGNORED = 0;
                _this.LASTMID = 0;
                _this.LASTVCHID = 0;
                $.each(res_obj,function(key,value){
                    _this.count = _this.count+1,
                    _this.created += parseInt(value.RESPONSE.CREATED._text),
                    _this.ALTERED += parseInt(value.RESPONSE.ALTERED._text),
                    _this.CANCELLED += parseInt(value.RESPONSE.CANCELLED._text),
                    _this.COMBINED += parseInt(value.RESPONSE.COMBINED._text),
                    _this.DELETED += parseInt(value.RESPONSE.DELETED._text),
                    _this.ERRORS += parseInt(value.RESPONSE.ERRORS._text),
                    _this.IGNORED += parseInt(value.RESPONSE.IGNORED._text),
                    _this.LASTMID += parseInt(value.RESPONSE.LASTMID._text),
                    _this.LASTVCHID += parseInt(value.RESPONSE.LASTVCHID._text)
                })
            }); 
        }
        else{
            var params={"xml":_this.voucher_create};
            axios.post('/insert_voucher_xml',params)
            .then((response)=>{
                    // console.log(response.data);
            })
        }
     }
     else{
         alert('you can-t enter the same voucher data twice');
     }
     $('.back').css('display','none');
     $('.import').css('display','none');
     $('.finish').css('display','block');
     _this.count=_this.count+1;
 }

//recurssion function
 function  data_render(template, json_data,value_unique_id_array,_this) {

     var ledger_arr = [];
     if (template, json_data) {
        $.each(template, function (key,value) {
           
             var array_name='';
             if(Array.isArray(value) == true){
                 array_name=key;
             }
             if (Array.isArray(template[key]) == true && key == "ALLINVENTORYENTRIES") {
                   array = set_inventory_data(value, value_unique_id_array,_this);
                   json_data[key]=array;
                   $.each(ledger_arr,function(ledger_k,ledger_v){
                    if(ledger_v.AMOUNT == "*Roundoff"){
                         ledger_v.AMOUNT=dr_value+cr_value;
                    }
                })
             }
             else if (Array.isArray(template[key]) == true && key != "ALLINVENTORYENTRIES") {
                 data_render(template[key], json_data[key],value_unique_id_array,_this);
                 if(key != "LEDGERENTRIES "){
                    ledger_arr = json_data[key];
                    $.each(ledger_arr,function(ledger_k,ledger_v){
                        if(ledger_v.AMOUNT == "*Roundoff" ){
                            if(array.length!=0){
                                ledger_v.AMOUNT=dr_value+cr_value;
                            }
                        }
                    })
                 }
             }
             else if (typeof template[key] === 'object' == true) {
                 data_render(template[key], json_data[key],value_unique_id_array,_this);
             }
             else {
                 if(array_name != "ALLINVENTORYENTRIES" || array_name != "ACCOUNTINGALLOCATIONS"){
                        for (var i = 0; i < 1; i++) {
                           $.each(value_unique_id_array[i], function (key_row,value_row) {
                                if (key_row == value) {
                                    json_data[key] = value_row;
                                    if(key == "AMOUNT"){
                                        if(template.ISDEEMEDPOSITIVE == "No"){
                                           cr_value += -value_row
                                        }
                                        else if(template.ISDEEMEDPOSITIVE == "Yes"){
                                           dr_value += value_row;
                                        }
                                    }
                                }
                            })
                        }
                 }
             }
          })
     }
 }

 function set_inventory_data(arr_inventory, object_excel_data,_this) {

     var inventory_template = JSON.parse(JSON.stringify(arr_inventory));
     var inventory_insertion_array = [];
     $.each(object_excel_data, function (key_excel_data,value_excel_data) {
         var inventory_data = JSON.parse(JSON.stringify(arr_inventory));
         if (key_excel_data != 0) {
             var array_name_roundoff = "";
             recurr_inventory(inventory_template, inventory_data,_this);
             async function recurr_inventory(inventory_template, inventory_data,_this) {
                $.each(inventory_template, function (key,value) {
                     if (Array.isArray(inventory_template[key]) == true) {
                         if(key=="ACCOUNTINGALLOCATIONS"){
                             array_name_roundoff = key;
                         }
                         recurr_inventory(inventory_template[key], inventory_data[key],_this)
                     }
                     else if (typeof inventory_template[key] === 'object' == true ) {
                         recurr_inventory(inventory_template[key], inventory_data[key],_this)
                     }
                     else {
                        $.each(value_excel_data, function (key_excel_data_col,value_excel_data_col ) {
                             if (key_excel_data_col == value && key != "RATE") {
                                 inventory_data[key] = value_excel_data_col;
                                 if(key=="AMOUNT" && array_name_roundoff=="ACCOUNTINGALLOCATIONS"){
                                    cr_value+=value_excel_data_col;
                                 }
                             }
                             if(key == "STOCKITEMNAME" && value == key_excel_data_col){
                                 if (_this.stockitem_ver) {
                                    $.each(_this.stockitem_ver, function (k_s,v_s) {
                                         if (v_s.name == value_excel_data_col) {
                                             unit = v_s.unit
                                         }
                                     })
                                 }
                             }
                             else if(key == "BILLEDQTY" && value == key_excel_data_col){
                                 billed_qty = parseInt(value_excel_data_col)
                             }
                             else if(key == "RATE" && value == key_excel_data_col){
                                 if (_this.stockitem_ver) {
                                     if(billed_qty){
                                         var rate_value = parseInt(value_excel_data_col)/billed_qty;
                                         var rate_value = Math.round(rate_value);
                                         var rate = rate_value.toString().concat("/");
                                         inventory_data[key] = rate.concat(unit);
                                     }
                                 }
                             }
                         })
                     }
                 })
             }
             inventory_insertion_array.push(inventory_data[0]);
         }
     })
     return  inventory_insertion_array;
 }

 function getTemplateName(_this,params){
   
    if(params.type && params.subtype && params.company_name){
            axios.get('templates/fetchTemplateNames',{params})
            .then((result)=>{
                 var templates = [];
              

                 templates =result.data.template_name_data;
                _this.template_data_php=result.data.template_data_array;
                _this.modal_template_data = result.data.template_data_array;
                if (templates.length == 0) {
                    $("#Name").find('option').remove();
                }
                else {
                    $.each(templates, function (key, value) {
                        if (value.length > 0) {
                            $("#Name").find('option').remove();
                        }
                    })
                    $.each(templates, function (key, value) {
                        if (value.length > 0){
                            _this.template_Options.items.push(value);
                        }
                    })
                }
        })
    }
 }

export{getJsonTemplatePhp,verifyMaster,voucher_data_render,getCompanyNames_db,getTemplateName}

